import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { Tooltip } from "../tooltip";
import { useConfig } from "../_util/config-context";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
import { teaIconsMap } from "./tea-icons-map";
var colorClassArray = ["success", "warning", "pending", "error", "brand"];
var getColorClass = function (color) {
    return colorClassArray.includes(color);
};
export var Icon = forwardRefWithStatics(function Icon(props, ref) {
    var _a;
    var classPrefix = useConfig().classPrefix;
    var _b = props.type, type = _b === void 0 ? "" : _b, size = props.size, className = props.className, tooltip = props.tooltip, link = props.link, color = props.color, style = props.style, htmlProps = __rest(props, ["type", "size", "className", "tooltip", "link", "color", "style"]);
    var label = type.replace("-blue", "").replace("-hover", "");
    // 查看 type 是否在 @tencent/tea-icons-react 中是否存在映射
    var IconComponent = teaIconsMap[type];
    var iconClassName = classNames(className, (_a = {},
        _a[classPrefix + "-icon"] = !IconComponent,
        _a[classPrefix + "-icon-" + type] = !IconComponent,
        _a[classPrefix + "-util-icon-" + color] = getColorClass(color),
        _a), {
        "size-s": size === "s",
        "size-l": size === "l",
    });
    var iconComponentProps = {
        ref: ref,
        className: iconClassName,
        role: "img",
        "aria-label": label,
        style: style,
    };
    var icon;
    // 没有映射，走老版本 icon
    if (!IconComponent) {
        var Parent = link ? "a" : "i";
        icon = React.createElement(Parent, __assign({}, iconComponentProps, htmlProps));
    }
    else {
        // size 是数字
        if (typeof size === "number") {
            Object.assign(iconComponentProps, { size: size });
        }
        else if (size === "l") {
            Object.assign(iconComponentProps, { size: 32 });
        }
        if (color) {
            Object.assign(iconComponentProps, { color: color });
        }
        var allProps = __assign(__assign({}, iconComponentProps), htmlProps);
        // 找到映射分支
        icon = link ? (React.createElement("a", __assign({}, allProps), React.cloneElement(IconComponent, iconComponentProps))) : (React.cloneElement(IconComponent, allProps));
    }
    if (tooltip) {
        return React.createElement(Tooltip, { title: tooltip }, icon);
    }
    return icon;
}, {});
Icon.displayName = "Icon";
//# sourceMappingURL=Icon.js.map